module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['single', {
      'is-hidden': _vm.singleIsHidden
    }]
  }, [_c('single-header', {
    attrs: {
      "project": _vm.project
    }
  }, [_c('p', [_vm._v("María is a visual and fine artist from Columbia now based in Berlin.\n        She works in painting, installation and illustration, as well as in art\n        direction and production design for media and film projects.")])]), _vm._v(" "), _c('single-section', [_c('video', {
    attrs: {
      "src": "assets/projects/maria-jose-moreno/slider.mp4",
      "autoplay": "",
      "loop": ""
    }
  })]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Dynamic WordPress"
    }
  }, [_c('p', [_vm._v("The slider on all pages are being loaded in dynamically to avoid a full page refresh.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/maria-jose-moreno/transition.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2c5a84"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/single/maria-jose-moreno.vue
// module id = 119
// module chunks = 0